import Vue from "vue";
import config from "@/config";
import errorTags from "@/errorTags";
import router from "@/router";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    language: "en",
    _loading: {
      login: false,
      logout: false,
      forgotPassword: false,
      memberSignUp: false,
      memberTacValidate: false,
      memberRenewTac: false,
      updatePassword: false,
      memberAddBank: false,
      memberBankTac: false,
      iBankTransfer: false,
      addDepositTicket: false,
      getPromotionStatus: false,
      addWithdrawTicket: false,
      getInbox: false,
      claimInbox: false,
      getReferralCode: false,
      addReferralCode: false,
      getTopTen: false,
      launchGame: false,
      transferTac: false,
      memberTransfer: false,
      getQuestion: false,
      submitReview: false,
      getSurveyList: false,
      submitVideoUrl: false,
      gsPayTransfer: false,
      // getCouponDetails: false,
      // couponGSPayTransfer: false,
      // iBankTransferCoupon: false,
      // addDepositTicketCoupon: false,
      getRefLink: false,
      updateEmail: false,
      peBankTransfer: false,
      // peBankTransferCoupon: false,
      winpay:false,
      // winpayCoupon: false,
      getRefereeList: false,
      getAdjustmentDetails: false,
      getRebateChart: false,
      getRebate: false,
      getRebateDownline: false,
      getTurnoverProvider:false,
      getMemberGameResult: false,
      claimRebate: false,
      claimRebateDownline:false,
      launchWbet: false,
      getProviderGameOfflist: false,
      getReferralRebateList:false,
      launchEpic: false,
      launchEpic2: false,
      launchLive22:false,
      launchMegaH5:false,
      launchHabanero: false,
      launchSpadeGaming: false,
      launchPragmatic: false,
      launchJoker: false,
      launchCq9: false,
      launchJili: false,
      launchOneapi:false,
      getSpadeResult: false,
      getPpsResult: false,
      getJokerResult: false,
      getHbResult: false,
      getEpic2Result:false,
      getLive22Result: false,
      getMegaH5Result:false,
      getCq9Result:false,
      getJiliResult:false,
      getOneapiResult:false,
      getMiniGameBalance:false,
      spinWheel:false,
    },
    transferDetails: [],
    promoDetails: [],
    platformWinLose:[],
    adjustmentDetails: [],
    refereeCount:[],
    depositCount: 0,
    betHistory: {
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    downlineList:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    livecasinoResult:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    slotResult:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    rebateResult:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    sbResult:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    // isPanel: false,
    tempName: "",
    tempPass: "",
    annBeforeLog: [],
    annAfterLog: [],
    refreshKey: 0,
    slotSelected: 0,
    platformSelected: "",
    firstLogin: false,
    inbox: [],
    referralCode: "",
    topten: [],
    currency_code: "MYR",
    account: "",
    balance: 0,
    gameToken: 0,
    transaction: "",
    // iosURL:
    //   "itms-services://?action=download-manifest&amp;url=https://w1.mc1128.com/epic/ios/prod_manifest.plist",
    iosURL: "http://w1.mc1128.com/epic/pwa/index.html",
    androidURL: "https://w1.mc1128.com/epic/android/epicwinc.apk",
    royaltyLevel: 0,
  },
  mutations: {
    updateLanguage(state, payload) {
      state.language = payload;
    },
    uTransferDetails(state, payload) {
      state.transferDetails = payload;
    },
    uBetHistory(state, payload) {
      state.betHistory = payload;
    },
    uPlatformWinLose(state, payload) {
      state.platformWinLose = payload.data;
    },
    uLivecasinoResult(state, payload) {
      state.livecasinoResult = payload;
    },
    uSlotResult(state, payload) {
      state.slotResult = payload;
    },
    uRebateResult(state, payload){
      state.rebateResult = payload
    },
    uSbResult(state, payload){
      state.sbResult = payload
    },
    uPromoDetails(state, payload) {
      state.promoDetails = payload;
    },
    uAdjustmentDetails(state, payload) {
      state.adjustmentDetails = payload;
    },
    uRefereeCount(state, payload) {
      state.refereeCount = payload;
    },
    update(state, payload) {
      state.account = payload.data;
    },
    uDepositCount(state, payload) {
      state.depositCount = payload;
    },
    delete(state) {
      state.account = "";
      state.transaction = "";
      state.balance = 0;
      state.gameToken = 0;
      state.livecasinoResult = {
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      }
      state.slotResult = {
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      }
      state.rebateResult ={
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      },
      state.sbResult ={
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      },
      state.downlineList = {
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      }
      state.inbox = [];
      state.royaltyLevel = 0;
      // window.sessionStorage.clear();
    },
    loading(state, payload) {
      if ("action" in payload) {
        const action = payload.action;
        const status = payload.status;
        state._loading[action] = status;
      }
    },
    updateBalance(state, payload) {
      state.balance = payload.game_balance;
      state.gameToken = payload.game_token
      // state.account.vip_level = payload.vip_level;
    },
    updateBank(state, payload) {
      state.transaction = payload;
    },
    updateLevel(state, payload) {
      state.vip_level = payload;
    },
    updateRefreshKey(state, payload) {
      state.refreshKey = payload;
    },
    updateSlotSelected(state, payload){
      state.slotSelected = payload;
    },
    updatePlatformSelected(state, payload){
      state.platformSelected = payload.user.category;
    },
    updateFirstLogin(state, payload){
      state.firstLogin = payload
    },
    updateInbox(state, payload) {
      state.inbox = payload;
    },
    updateTopTen(state, payload) {
      state.topten = payload;
    },
    // updateIsPanel(state, payload){
    //   state.isPanel = payload
    // },
    updateTempName(state,payload){
      state.tempName = payload;
    },
    updateTempPass(state, payload){
      state.tempPass = payload
    },
    updateRoyaltyLevel(state, payload){
      state.royaltyLevel = payload
    },
    updateEmail(state, payload){
      state.account.contact_email = payload
    },
    uDownlineList(state, payload) {
      state.downlineList = payload;
    },
    updateBetTeam(state, payload) {
      state.account.bet_team = payload;
    },

    /* cms */
    updateAnnBeforeLog(state, payload){
      state.annBeforeLog = payload
    },
    updateAnnAfterLog(state, payload){
      state.annAfterLog = payload
    },
  },
  actions: {
    // updatePanel(context, payload){
    //   context.commit("updateIsPanel", payload)
    // },
    annBeforeLog(context,payload){
      context.commit("updateAnnBeforeLog", payload)
    },
    annAfterLog(context,payload){
      context.commit("updateAnnAfterLog", payload)
    },
    setLanguage(context, payload) {
      i18n.locale = payload;
      context.commit("updateLanguage", payload);
    },
    tempAccName(context,payload){
      context.commit("updateTempName", payload)
    },
    tempPass(context, payload){
      context.commit("updateTempPass", payload)
    },
    sTransferDetails(context, payload) {
      context.commit("uTransferDetails", payload);
    },
    sBetHistory(context, payload) {
      context.commit("uBetHistory", payload);
    },
    sPlatformWinLose(context, payload) {
      context.commit("uPlatformWinLose", payload);
    },
    sLivecasinoResult(context, payload){
      context.commit("uLivecasinoResult", payload)
    },
    sSlotResult(context, payload){
      context.commit("uSlotResult", payload)
    },
    sRebateResult(context, payload){
      context.commit("uRebateResult", payload)
    },
    sSbResult(context, payload){
      context.commit("uSbResult", payload)
    },
    sPromoDetails(context, payload) {
      context.commit("uPromoDetails", payload);
    },
    sAdjustmentDetails(context, payload) {
      context.commit("uAdjustmentDetails", payload);
    },
    sRefereeCount(context, payload) {
      context.commit("uRefereeCount", payload);
    },
    setRefreshKey(context, payload) {
      context.commit("updateRefreshKey", payload);
    },
    setSlotSelected(context, payload){
      context.commit("updateSlotSelected", payload);
    },
    firstLogin(context, payload){
      context.commit("updateFirstLogin", payload)
    },
    setRoyaltyLevel(context, payload){
      context.commit("updateRoyaltyLevel", payload);
    },
    setEmail(context, payload){
      context.commit("updateEmail", payload)
    },
    sDownlineList(context, payload) {
      context.commit("uDownlineList", payload);
    },
    updateEuro(context,payload){
      context.commit("updateBetTeam", payload)
    },
    login(context, user) {
      const url = config.memberLogin();
      const body = {
        account_id: user.username,
        password: user.password
      };
      const feedback = {
        success: false,
        status: errorTags.login.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("username" in user)) {
          feedback.status = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.username.length <= 0) {
          feedback.status = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.login == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "login", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "login", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var sessionToken = null;
                  var data = null;
                  try {
                    sessionToken = successResponse.data.value[0].session_token;
                    data = successResponse.data.value[0];
                    
                    if (sessionToken) {
                      context.commit("update", { data });
                      // let account_id = user.username
                      // let auth_token = sessionToken
                      // let app_id = user.app_id
                      // commit("getInbox", {account_id, auth_token, app_id})
                      // dispatch('getInbox', null, { root: true })
                      resolve(feedback);
                    } else {
                      context.commit("delete");
                      feedback.success = false;
                      feedback.status = errorTags.login.failed;
                      reject(feedback);
                    }
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorTags.login.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  // router.push("/").catch(err=>{});
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "login", status: false });
              context.commit("delete");
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    logout(context) {
      const feedback = {
        success: true,
        status: errorTags.logout.succeed
      };
      return new Promise(resolve => {
        context.commit("delete");
        resolve(feedback);
      });
    },
    forgotPassword(context, user) {
      const url = config.forgotPassword();
      const body = {
        account_id: user.account_id,
        // verification_code: user.verification_code
      };
      const feedback = {
        success: false,
        status: errorTags.forgotPassword.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.forgotPassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        // if (!("verification_code" in user)) {
        //   feedback.status = errorTags.forgotPassword.verificationCodeRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.forgotPassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        // if (user.verification_code.length <= 0) {
        //   feedback.status = errorTags.forgotPassword.verificationCodeRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (this.state.user._loading.forgotPassword == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "forgotPassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "forgotPassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.forgotPassword.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "forgotPassword",
                status: false
              });
              context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    debounceSearch(context, user) {
      const url = config.debounceSearch();
      const body = {
        account_id: user.account_id
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.debounceSearch.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.debounceSearch.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.debounceSearch.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          Vue.http.post(url, body).then(
            successResponse => {
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value[0];
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberSignUp(context, user) {
      const url = config.membersignup();
      const body = {
        account_id: user.account_id,
        password: user.password,
        contact_phone: user.contact_phone,
        referral_code: user.referral_code,
        affiliate_code: user.affiliate_code,
        ch: user.ch,
        cm: user.cm,
        pp: user.pp
      };
      const feedback = {
        success: false,
        status: errorTags.memberSignUp.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.memberSignUp.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.memberSignUp.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.memberSignUp.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.memberSignUp.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.memberSignUp == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "memberSignUp", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "memberSignUp",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "memberSignUp",
                status: false
              });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberTacValidate(context, user) {
      const url = config.memberTacValidate();
      const body = {
        account_id: user.account_id,
        tac: user.tac_code,
        referral_code: user.referral_code,
        contact_email: user.contact_email
      };
      const feedback = {
        success: false,
        status: errorTags.memberTacValidate.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.memberTacValidate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("tac_code" in user)) {
          feedback.status = errorTags.memberTacValidate.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.memberTacValidate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.tac_code.length <= 0) {
          feedback.status = errorTags.memberTacValidate.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.memberTacValidate == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "memberTacValidate",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "memberTacValidate",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "memberTacValidate",
                status: false
              });
              context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberRenewTac(context, user) {
      const url = config.memberRenewTac();
      const body = {
        account_id: user.account_id
      };
      const feedback = {
        success: false,
        status: errorTags.memberRenewTac.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.memberRenewTac.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.memberRenewTac.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.memberRenewTac == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "memberRenewTac", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "memberRenewTac",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "memberRenewTac",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getBalance(context, user) {
      const url = config.getBalance();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getBalance.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getBalance.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getBalance.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getBalance == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getBalance", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getBalance", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value[0];
                    context.commit("updateBalance", feedback.data);
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }

                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }

                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                // router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getBalance", status: false });
              // if(errorResponse.status != 0){
              //   context.commit("delete");
              //   router.push("/").catch(err => {});
              // }
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    bankLookUp(context, user) {
      const url = config.bankLookUp();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.bankLookUp.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.bankLookUp.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.bankLookUp.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.bankLookUp == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "bankLookUp", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "bankLookUp", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "bankLookUp", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberBankList(context, user) {
      const url = config.getMemberBankList();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberBankList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getMemberBankList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getMemberBankList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getMemberBankList == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getMemberBankList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getMemberBankList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;
                  try {
                    feedback.data = successResponse.data.value;
                    data = successResponse.data.value;
                    context.commit("updateBank", data);
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getMemberBankList", status: false });
              context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getBankingMode(context, user) {
      const url = config.getBankingMode();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getBankingMode.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getBankingMode.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getBankingMode.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getBankingMode == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getBankingMode", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getBankingMode", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getBankingMode", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePassword(context, user) {
      const url = config.updatePassword();
      const body = {
        account_id: user.account_id,
        password: user.password,
        new_password: user.new_password,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.updatePassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.updatePassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("new_password" in user)) {
          feedback.status = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.updatePassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.new_password.length <= 0) {
          feedback.status = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePassword == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updatePassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberAddBank(context, user) {
      const url = config.memberAddBank();
      const body = {
        account_id: user.account_id,
        bank_id: user.bank_id,
        bank_name: user.bank_name,
        bank_acc_holder: user.bank_acc_holder,
        bank_acc_no: user.bank_acc_no,
        tac: user.tac_code,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.memberAddBank.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.memberAddBank.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_id" in user)) {
          feedback.status = errorTags.memberAddBank.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_name" in user)) {
          feedback.status = errorTags.memberAddBank.bankNameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_acc_holder" in user)) {
          feedback.status = errorTags.memberAddBank.bankAccHolderRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_acc_no" in user)) {
          feedback.status = errorTags.memberAddBank.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("tac_code" in user)) {
          feedback.status = errorTags.memberAddBank.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.memberAddBank.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_id.length <= 0) {
          feedback.status = errorTags.memberAddBank.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_name.length <= 0) {
          feedback.status = errorTags.memberAddBank.bankNameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_acc_holder.length <= 0) {
          feedback.status = errorTags.memberAddBank.bankAccHolderRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_acc_no.length <= 0) {
          feedback.status = errorTags.memberAddBank.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.tac_code.length <= 0) {
          feedback.status = errorTags.memberAddBank.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.memberAddBank == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "memberAddBank", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "memberAddBank",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "memberAddBank",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberBankTac(context, user) {
      const url = config.memberBankTac();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        success: false,
        status: errorTags.memberBankTac.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.memberBankTac.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.memberBankTac.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.memberBankTac == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "memberBankTac", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "memberBankTac",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "memberBankTac",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    iBankTransfer(context, user) {
      const url = config.iBankTransfer();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        target_bank_id: user.target_bank_id,
        package_id: user.package_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.iBankTransfer.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.iBankTransfer.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.iBankTransfer.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("target_bank_id" in user)) {
          feedback.status = errorTags.iBankTransfer.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.iBankTransfer.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.iBankTransfer.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.target_bank_id.length <= 0) {
          feedback.status = errorTags.iBankTransfer.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.iBankTransfer == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "iBankTransfer", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "iBankTransfer",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "iBankTransfer",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addDepositTicket(context, user) {
      const url = config.addDepositTicket();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        target_bank_id: user.target_bank_id,
        target_bank_acc_no: user.target_bank_acc_no,
        target_bank_acc_holder: user.target_bank_acc_holder,
        ref_no: user.ref_no,
        attachment_path: user.attachment_path,
        deposit_date: user.deposit_date,
        deposit_method: user.deposit_method,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        success: false,
        status: errorTags.addDepositTicket.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.addDepositTicket.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.addDepositTicket.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("target_bank_id" in user)) {
          feedback.status = errorTags.addDepositTicket.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("target_bank_acc_no" in user)) {
          feedback.status = errorTags.addDepositTicket.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("target_bank_acc_holder" in user)) {
          feedback.status = errorTags.addDepositTicket.bankAccNameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("ref_no" in user)) {
          feedback.status = errorTags.addDepositTicket.refNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_date" in user)) {
          feedback.status = errorTags.addDepositTicket.depositDateRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_method" in user)) {
          feedback.status = errorTags.addDepositTicket.depositMethodRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.status = errorTags.addDepositTicket.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.addDepositTicket.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.target_bank_id.length <= 0) {
          feedback.status = errorTags.addDepositTicket.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.target_bank_acc_no.length <= 0) {
          feedback.status = errorTags.addDepositTicket.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.target_bank_acc_holder.length <= 0) {
          feedback.status = errorTags.addDepositTicket.bankAccNameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ref_no.length <= 0) {
          feedback.status = errorTags.addDepositTicket.refNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_date.length <= 0) {
          feedback.status = errorTags.addDepositTicket.depositDateRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_method.length <= 0) {
          feedback.status = errorTags.addDepositTicket.depositMethodRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addDepositTicket == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "addDepositTicket",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "addDepositTicket",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "addDepositTicket",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberTicketList(context, user) {
      const url = config.getMemberTicketList();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberTicketList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getMemberTicketList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getMemberTicketList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getMemberTicketList == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getMemberTicketList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getMemberTicketList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                // router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getMemberTicketList", status: false });
              // context.commit("delete");
              // router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPromotionStatus(context, user) {
      const url = config.getPromotionStatus();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getPromotionStatus.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getPromotionStatus.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getPromotionStatus.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getPromotionStatus == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getPromotionStatus", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getPromotionStatus", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                // router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getPromotionStatus", status: false });
              // context.commit("delete");
              // router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addWithdrawTicket(context, user) {
      const url = config.addWithdrawTicket();
      const body = {
        account_id: user.account_id,
        withdrawal_amount: user.withdrawal_amount,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        success: false,
        status: errorTags.addWithdrawTicket.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.addWithdrawTicket.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("withdrawal_amount" in user)) {
          feedback.status =
            errorTags.addWithdrawTicket.withdrawalAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.status = errorTags.addWithdrawTicket.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.withdrawal_amount.length <= 0) {
          feedback.status =
            errorTags.addWithdrawTicket.withdrawalAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addWithdrawTicket == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "addWithdrawTicket",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "addWithdrawTicket",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "addWithdrawTicket",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberTransferDetails(context, user) {
      const url = config.getMemberTransferDetails();
      const body = {
        account_id: user.account_id,
        working_date: user.working_date,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getStatement == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberGameResult(context, user) {
      const url = user.url
      const body = {
        account_id: user.account_id,
        working_date: user.working_date,
        page_size: user.page_size,
        page_number: user.page_number,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getMemberGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getMemberGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getMemberGameResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "getMemberGameResult", status: true });
          context.commit("updatePlatformSelected", { user });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getMemberGameResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getMemberGameResult", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPlatformWinLose(context, user) {
      const url = config.getPlatformWinLose();
      const body = {
        account_id: user.account_id,
        working_date: user.working_date,
        // page_size: user.page_size,
        // page_number: user.page_number,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getStatement == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberStatement(context, user) {
      const url = config.getMemberStatement();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getStatement == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPromoStatement(context, user) {
      const url = config.getPromoStatement();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        working_date: user.working_date,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getStatement == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getAdjustmentDetails(context, user) {
      const url = config.getAdjustmentDetails();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        working_date: user.working_date,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getAdjustmentDetails.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getAdjustmentDetails.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getAdjustmentDetails.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getAdjustmentDetails == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getAdjustmentDetails", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getAdjustmentDetails", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getAdjustmentDetails", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getRefereeList(context, user) {
      const url = config.getRefereeList();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        working_date: user.working_date
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getRefereeList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getRefereeList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getRefereeList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getRefereeList == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getRefereeList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getRefereeList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getRefereeList", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getInbox(context, user) {
      const url = config.getInboxList();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        success: false,
        status: errorTags.getInbox.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getInbox.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getInbox.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        // if (this.state.user._loading.getInbox == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getInbox", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getInbox", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    context.commit("updateInbox", successResponse.data.value);
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getInbox", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    claimInbox(context, user) {
      const url = config.inboxClaim();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
        inbox_id: user.inbox_id
      };
      const feedback = {
        success: false,
        status: errorTags.claimInbox.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.claimInbox.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.claimInbox.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("inbox_id" in user)) {
          feedback.status = errorTags.claimInbox.bonusIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.inbox_id.length <= 0) {
          feedback.status = errorTags.claimInbox.bonusIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.claimInbox == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "claimInbox", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "claimInbox",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // store.dispatch("user/getBalance", user);
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "claimInbox",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getReferralCode(context, user) {
      const url = config.getReferralCode();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getReferralCode.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getReferralCode.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getReferralCode.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.getReferralCode == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getReferralCode",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getReferralCode",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.data.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getReferralCode",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addReferralCode(context, user) {
      const url = config.addReferralCode();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.addReferralCode.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.addReferralCode.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.addReferralCode.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.addReferralCode == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "addReferralCode",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "addReferralCode",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.data.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "addReferralCode",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    openSlotGame(context, user) {
      const url = config.launchGame();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
        game_code: user.game_code,
        lang: user.lang
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchGame.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.addReferralCode.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.addReferralCode.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.launchGame == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "launchGame", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "launchGame",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.data.url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "launchGame",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    transferTac(context, user) {
      const url = config.transferTac();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        success: false,
        status: errorTags.transferTac.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.transferTac.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.transferTac.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.transferTac == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "transferTac", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "transferTac",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "transferTac",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberTransfer(context, user) {
      const url = config.memberTransferMember();
      const body = {
        account_id: user.account_id,
        transfer_amount: user.transfer_amount,
        tac_code: user.tac_code,
        recipient_id : user.recipient_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        success: false,
        status: errorTags.memberTransfer.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.memberTransfer.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("transfer_amount" in user)) {
          feedback.status = errorTags.memberTransfer.transferAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("tac_code" in user)) {
          feedback.status = errorTags.memberTransfer.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("recipient_id" in user)) {
          feedback.status = errorTags.memberTransfer.recipientIdRequired;
          reject(feedback);
          canRequest = false;
        }
        
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.memberTransfer.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.transfer_amount.length <= 0) {
          feedback.status = errorTags.memberTransfer.transferAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        
        if (user.tac_code.length <= 0) {
          feedback.status = errorTags.memberTransfer.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        
        if (user.recipient_id.length <= 0) {
          feedback.status = errorTags.memberTransfer.recipientIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.memberTransfer == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "memberTransfer",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "memberTransfer",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "memberTransfer",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getQuestion(context, user) {
      const url = config.getSurveyQuestion();
      const body = {
        op: user.comp
      };
      const feedback = {
        success: false,
        status: errorTags.getQuestion.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getQuestion == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getQuestion",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getQuestion",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data= successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getQuestion",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    submitReview(context, user) {
      const url = config.memberReview();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        json_rating: user.json_rating,
        comment: user.comment,
        recipient_no: user.recipient_no
      };
      const feedback = {
        success: false,
        status: errorTags.submitReview.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.submitReview.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.status = errorTags.submitReview.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (!("recipient_no" in user)) {
        //   feedback.status = errorTags.submitReview.recipientIdRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (user.recipient_no.length <= 0) {
        //   feedback.status = errorTags.submitReview.recipientIdRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (!("comment" in user)) {
          feedback.status = errorTags.submitReview.commentRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.comment.length <= 0) {
          feedback.status = errorTags.submitReview.commentRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("json_rating" in user)) {
          feedback.status = errorTags.submitReview.ratingRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.json_rating.length <= 0) {
          feedback.status = errorTags.submitReview.ratingRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.submitReview == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "submitReview",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "submitReview",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data= successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "submitReview",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSurveyList(context, user) {
      const url = config.getTopTenReview();
      const body = {
        op: user.comp,
      };
      const feedback = {
        success: false,
        status: errorTags.getSurveyList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getSurveyList == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSurveyList",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSurveyList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data= successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSurveyList",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    submitVideoUrl(context, user) {
      const url = config.submitVideoUrl();
      const body = {
        
        account_id: user.account_id,
        auth_token: user.auth_token,
        video_url: user.video_url
      };
      const feedback = {
        success: false,
        status: errorTags.submitVideoUrl.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.submitVideoUrl == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (!("account_id" in user)) {
          feedback.status = errorTags.submitVideoUrl.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.status = errorTags.submitVideoUrl.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("video_url" in user)) {
          feedback.status = errorTags.submitVideoUrl.videoLinkRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.video_url.length <= 0) {
          feedback.status = errorTags.submitVideoUrl.videoLinkRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "submitVideoUrl",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "submitVideoUrl",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data= successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "submitVideoUrl",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    gsPayTransfer(context, user) {
      const url = config.gsPayTransfer();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.package_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.gsPayTransfer.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.gsPayTransfer.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.gsPayTransfer.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.gsPayTransfer.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.gsPayTransfer.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.gsPayTransfer == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          context.commit("loading", { action: "gsPayTransfer", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "gsPayTransfer",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_gspay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "gsPayTransfer",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    // getCouponDetails(context, user) {
    //   const url = config.getCouponDetails();
    //   const body = {
    //     account_id: user.account_id,
    //     coupon_code: user.coupon_code,
    //     auth_token: user.auth_token,
        
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     status: errorTags.getCouponDetails.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.status = errorTags.getCouponDetails.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.account_id.length <= 0) {
    //       feedback.status = errorTags.getCouponDetails.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (this.state.user._loading.getCouponDetails == true) {
    //       feedback.status = errorTags.request.processing;
    //       canRequest = false;
    //     }

    //     if (canRequest == true) {
    //       context.commit("loading", { action: "getCouponDetails", status: true });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           context.commit("loading", {
    //             action: "getCouponDetails",
    //             status: false
    //           });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == 1;
    //             }
    //             feedback.status = successResponse.body.statusdesc;
    //             if (feedback.success == true) {
    //               try {
    //                 feedback.data = successResponse.body.value
    //                 resolve(feedback);
    //               } catch (error) {
    //                 if (
    //                   feedback.status == errorTags.session.expired ||
    //                   feedback.status == errorTags.session.invalidSession
    //                 ) {
    //                   context.commit("delete");
    //                   router.push("/").catch(err => {});
    //                 }
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.status == errorTags.session.expired ||
    //                 feedback.status == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/").catch(err => {});
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             context.commit("delete");
    //             router.push("/").catch(err => {});
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           context.commit("loading", {
    //             action: "getCouponDetails",
    //             status: false
    //           });
    //           context.commit("delete");
    //           router.push("/").catch(err => {});
    //           feedback.status = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    // couponGSPayTransfer(context, user) {
    //   const url = config.gsPayCoupon();
    //   const body = {
    //     account_id: user.account_id,
    //     deposit_amount: user.deposit_amount,
    //     // target_bank_id: "GSPAY",
    //     coupon_code: user.coupon_code,
    //     auth_token: user.auth_token,
        
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     status: errorTags.couponGSPayTransfer.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.status = errorTags.couponGSPayTransfer.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("deposit_amount" in user)) {
    //       feedback.status = errorTags.couponGSPayTransfer.depositAmountRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.account_id.length <= 0) {
    //       feedback.status = errorTags.couponGSPayTransfer.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.deposit_amount.length <= 0) {
    //       feedback.status = errorTags.couponGSPayTransfer.depositAmountRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (this.state.user._loading.couponGSPayTransfer == true) {
    //       feedback.status = errorTags.request.processing;
    //       canRequest = false;
    //     }

    //     if (canRequest == true) {
    //       context.commit("loading", { action: "couponGSPayTransfer", status: true });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           context.commit("loading", {
    //             action: "couponGSPayTransfer",
    //             status: false
    //           });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == 1;
    //             }
    //             feedback.status = successResponse.body.statusdesc;
    //             if (feedback.success == true) {
    //               try {
    //                 feedback.data = successResponse.body.pg_gspay_url;
    //                 resolve(feedback);
    //               } catch (error) {
    //                 if (
    //                   feedback.status == errorTags.session.expired ||
    //                   feedback.status == errorTags.session.invalidSession
    //                 ) {
    //                   context.commit("delete");
    //                   router.push("/").catch(err => {});
    //                 }
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.status == errorTags.session.expired ||
    //                 feedback.status == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/").catch(err => {});
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             context.commit("delete");
    //             router.push("/").catch(err => {});
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           context.commit("loading", {
    //             action: "couponGSPayTransfer",
    //             status: false
    //           });
    //           context.commit("delete");
    //           router.push("/").catch(err => {});
    //           feedback.status = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    // iBankTransferCoupon(context, user) {
    //   const url = config.iBankCoupon();
    //   const body = {
    //     account_id: user.account_id,
    //     deposit_amount: user.deposit_amount,
    //     target_bank_id: user.target_bank_id,
    //     coupon_code: user.coupon_code,
    //     auth_token: user.auth_token,
        
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     status: errorTags.iBankTransferCoupon.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.status = errorTags.iBankTransferCoupon.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("deposit_amount" in user)) {
    //       feedback.status = errorTags.iBankTransferCoupon.depositAmountRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("target_bank_id" in user)) {
    //       feedback.status = errorTags.iBankTransferCoupon.bankIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.account_id.length <= 0) {
    //       feedback.status = errorTags.iBankTransferCoupon.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.deposit_amount.length <= 0) {
    //       feedback.status = errorTags.iBankTransferCoupon.depositAmountRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.target_bank_id.length <= 0) {
    //       feedback.status = errorTags.iBankTransferCoupon.bankIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (this.state.user._loading.iBankTransferCoupon == true) {
    //       feedback.status = errorTags.request.processing;
    //       canRequest = false;
    //     }

    //     if (canRequest == true) {
    //       context.commit("loading", { action: "iBankTransferCoupon", status: true });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           context.commit("loading", {
    //             action: "iBankTransferCoupon",
    //             status: false
    //           });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == 1;
    //             }
    //             feedback.status = successResponse.body.statusdesc;
    //             if (feedback.success == true) {
    //               try {
    //                 feedback.data = successResponse.body.value;
    //                 resolve(feedback);
    //               } catch (error) {
    //                 if (
    //                   feedback.status == errorTags.session.expired ||
    //                   feedback.status == errorTags.session.invalidSession
    //                 ) {
    //                   context.commit("delete");
    //                   router.push("/").catch(err => {});
    //                 }
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.status == errorTags.session.expired ||
    //                 feedback.status == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/").catch(err => {});
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             context.commit("delete");
    //             router.push("/").catch(err => {});
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           context.commit("loading", {
    //             action: "iBankTransferCoupon",
    //             status: false
    //           });
    //           context.commit("delete");
    //           router.push("/").catch(err => {});
    //           feedback.status = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    // addDepositTicketCoupon(context, user) {
    //   const url = config.addDepositTicketCoupon();
    //   const body = {
    //     account_id: user.account_id,
    //     deposit_amount: user.deposit_amount,
    //     target_bank_id: user.target_bank_id,
    //     target_bank_acc_no: user.target_bank_acc_no,
    //     target_bank_acc_holder: user.target_bank_acc_holder,
    //     ref_no: user.ref_no,
    //     attachment_path: user.attachment_path,
    //     deposit_date: user.deposit_date,
    //     deposit_method: user.deposit_method,
    //     coupon_code: user.coupon_code,
    //     auth_token: user.auth_token,
        
    //   };
    //   const feedback = {
    //     success: false,
    //     status: errorTags.addDepositTicketCoupon.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.status = errorTags.addDepositTicketCoupon.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("deposit_amount" in user)) {
    //       feedback.status = errorTags.addDepositTicketCoupon.depositAmountRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("target_bank_id" in user)) {
    //       feedback.status = errorTags.addDepositTicketCoupon.bankIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("target_bank_acc_no" in user)) {
    //       feedback.status = errorTags.addDepositTicketCoupon.bankAccNoRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("target_bank_acc_holder" in user)) {
    //       feedback.status = errorTags.addDepositTicketCoupon.bankAccNameRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("ref_no" in user)) {
    //       feedback.status = errorTags.addDepositTicketCoupon.refNoRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("deposit_date" in user)) {
    //       feedback.status = errorTags.addDepositTicketCoupon.depositDateRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("deposit_method" in user)) {
    //       feedback.status = errorTags.addDepositTicketCoupon.depositMethodRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (user.account_id.length <= 0) {
    //       feedback.status = errorTags.addDepositTicketCoupon.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.deposit_amount.length <= 0) {
    //       feedback.status = errorTags.addDepositTicketCoupon.depositAmountRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.target_bank_id.length <= 0) {
    //       feedback.status = errorTags.addDepositTicketCoupon.bankIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.target_bank_acc_no.length <= 0) {
    //       feedback.status = errorTags.addDepositTicketCoupon.bankAccNoRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.target_bank_acc_holder.length <= 0) {
    //       feedback.status = errorTags.addDepositTicketCoupon.bankAccNameRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.ref_no.length <= 0) {
    //       feedback.status = errorTags.addDepositTicketCoupon.refNoRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.deposit_date.length <= 0) {
    //       feedback.status = errorTags.addDepositTicketCoupon.depositDateRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.deposit_method.length <= 0) {
    //       feedback.status = errorTags.addDepositTicketCoupon.depositMethodRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (this.state.user._loading.addDepositTicketCoupon == true) {
    //       feedback.status = errorTags.request.processing;
    //       canRequest = false;
    //     }

    //     if (canRequest == true) {
    //       context.commit("loading", {
    //         action: "addDepositTicketCoupon",
    //         status: true
    //       });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           context.commit("loading", {
    //             action: "addDepositTicketCoupon",
    //             status: false
    //           });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == 1;
    //             }
    //             feedback.status = successResponse.body.statusdesc;
    //             if (feedback.success == true) {
    //               try {
    //                 resolve(feedback);
    //               } catch (error) {
    //                 if (
    //                   feedback.status == errorTags.session.expired ||
    //                   feedback.status == errorTags.session.invalidSession
    //                 ) {
    //                   context.commit("delete");
    //                   router.push("/").catch(err => {});
    //                 }
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.status == errorTags.session.expired ||
    //                 feedback.status == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/").catch(err => {});
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             context.commit("delete");
    //             router.push("/").catch(err => {});
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           context.commit("loading", {
    //             action: "addDepositTicketCoupon",
    //             status: false
    //           });
    //           context.commit("delete");
    //           router.push("/").catch(err => {});
    //           feedback.status = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    peBankTransfer(context, user) {
      const url = config.peBankTransfer();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        target_bank_id: user.target_bank_id,
        promotion_id: user.package_id,
        auth_token: user.auth_token,
        
        method: user.method
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.peBankTransfer.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.peBankTransfer.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.peBankTransfer.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("target_bank_id" in user)) {
          feedback.status = errorTags.iBankTransfer.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("method" in user)) {
          feedback.status = errorTags.peBankTransfer.depositMethodRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.peBankTransfer.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.peBankTransfer.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.method.length <= 0) {
          feedback.status = errorTags.peBankTransfer.depositMethodRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.target_bank_id.length <= 0) {
          feedback.status = errorTags.addDepositTicket.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.peBankTransfer == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "peBankTransfer", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "peBankTransfer",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value[0].url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "peBankTransfer",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    // peBankTransferCoupon(context, user) {
    //   const url = config.peCoupon();
    //   const body = {
    //     account_id: user.account_id,
    //     deposit_amount: user.deposit_amount,
    //     target_bank_id: user.target_bank_id,
    //     coupon_code: user.coupon_code,
    //     auth_token: user.auth_token,
        
    //     method: user.method
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     status: errorTags.peBankTransferCoupon.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.status = errorTags.peBankTransferCoupon.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("deposit_amount" in user)) {
    //       feedback.status = errorTags.peBankTransferCoupon.depositAmountRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("target_bank_id" in user)) {
    //       feedback.status = errorTags.peBankTransferCoupon.bankIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("method" in user)) {
    //       feedback.status = errorTags.peBankTransferCoupon.bankIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.account_id.length <= 0) {
    //       feedback.status = errorTags.peBankTransferCoupon.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.deposit_amount.length <= 0) {
    //       feedback.status = errorTags.peBankTransferCoupon.depositAmountRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.target_bank_id.length <= 0) {
    //       feedback.status = errorTags.peBankTransferCoupon.bankIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.method.length <= 0) {
    //       feedback.status = errorTags.peBankTransferCoupon.bankIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (this.state.user._loading.peBankTransferCoupon == true) {
    //       feedback.status = errorTags.request.processing;
    //       canRequest = false;
    //     }

    //     if (canRequest == true) {
    //       context.commit("loading", { action: "peBankTransferCoupon", status: true });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           context.commit("loading", {
    //             action: "peBankTransferCoupon",
    //             status: false
    //           });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == 1;
    //             }
    //             feedback.status = successResponse.body.statusdesc;
    //             if (feedback.success == true) {
    //               try {
    //                 feedback.data = successResponse.body.value[0].url;
    //                 resolve(feedback);
    //               } catch (error) {
    //                 if (
    //                   feedback.status == errorTags.session.expired ||
    //                   feedback.status == errorTags.session.invalidSession
    //                 ) {
    //                   context.commit("delete");
    //                   router.push("/").catch(err => {});
    //                 }
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.status == errorTags.session.expired ||
    //                 feedback.status == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/").catch(err => {});
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             context.commit("delete");
    //             router.push("/").catch(err => {});
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           context.commit("loading", {
    //             action: "peBankTransferCoupon",
    //             status: false
    //           });
    //           context.commit("delete");
    //           router.push("/").catch(err => {});
    //           feedback.status = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    winpay(context, user) {
      const url = config.winpay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        target_bank_id: user.target_bank_id,
        promotion_id: user.package_id,
        auth_token: user.auth_token,
        
        telcoCode: user.telcoCode,
        reloadPinCode: user.reloadPinCode
      };
      // alert(JSON.stringify(body))
      const feedback = {
        data: [],
        success: false,
        status: errorTags.winpay.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.winpay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.winpay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("target_bank_id" in user)) {
          feedback.status = errorTags.winpay.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("telcoCode" in user)) {
          feedback.status = errorTags.winpay.telcoCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("reloadPinCode" in user)) {
          feedback.status = errorTags.winpay.reloadPinCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.winpay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.winpay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.telcoCode.length <= 0) {
          feedback.status = errorTags.winpay.telcoCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.reloadPinCode.length <= 0) {
          feedback.status = errorTags.winpay.reloadPinCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.target_bank_id.length <= 0) {
          feedback.status = errorTags.winpay.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.winpay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "winpay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "winpay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // feedback.data = successResponse.body.value[0].url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "winpay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    // winpayCoupon(context, user) {
    //   const url = config.winpayCoupon();
    //   const body = {
    //     account_id: user.account_id,
    //     deposit_amount: user.deposit_amount,
    //     target_bank_id: user.target_bank_id,
    //     coupon_code: user.coupon_code,
    //     auth_token: user.auth_token,
        
    //     telcoCode: user.telcoCode,
    //     reloadPinCode: user.reloadPinCode
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     status: errorTags.winpayCoupon.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.status = errorTags.winpayCoupon.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("deposit_amount" in user)) {
    //       feedback.status = errorTags.winpayCoupon.depositAmountRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("target_bank_id" in user)) {
    //       feedback.status = errorTags.winpayCoupon.bankIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("telcoCode" in user)) {
    //       feedback.status = errorTags.winpay.telcoCodeRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("reloadPinCode" in user)) {
    //       feedback.status = errorTags.winpay.reloadPinCodeRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.account_id.length <= 0) {
    //       feedback.status = errorTags.winpayCoupon.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.deposit_amount.length <= 0) {
    //       feedback.status = errorTags.winpayCoupon.depositAmountRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.target_bank_id.length <= 0) {
    //       feedback.status = errorTags.winpayCoupon.bankIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.telcoCode.length <= 0) {
    //       feedback.status = errorTags.winpay.telcoCodeRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.reloadPinCode.length <= 0) {
    //       feedback.status = errorTags.winpay.reloadPinCodeRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (this.state.user._loading.winpayCoupon == true) {
    //       feedback.status = errorTags.request.processing;
    //       canRequest = false;
    //     }

    //     if (canRequest == true) {
    //       context.commit("loading", { action: "winpayCoupon", status: true });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           context.commit("loading", {
    //             action: "winpayCoupon",
    //             status: false
    //           });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == 1;
    //             }
    //             feedback.status = successResponse.body.statusdesc;
    //             if (feedback.success == true) {
    //               try {
    //                 // feedback.data = successResponse.body.value[0].url;
    //                 resolve(feedback);
    //               } catch (error) {
    //                 if (
    //                   feedback.status == errorTags.session.expired ||
    //                   feedback.status == errorTags.session.invalidSession
    //                 ) {
    //                   context.commit("delete");
    //                   router.push("/").catch(err => {});
    //                 }
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.status == errorTags.session.expired ||
    //                 feedback.status == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/").catch(err => {});
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             context.commit("delete");
    //             router.push("/").catch(err => {});
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           context.commit("loading", {
    //             action: "winpayCoupon",
    //             status: false
    //           });
    //           context.commit("delete");
    //           router.push("/").catch(err => {});
    //           feedback.status = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    // apiClevertapProfile(context, user) {
    //   const url = config.cleverTapProfile();
    //   const body = {
    //     account_id: user.account_id,
    //     auth_token: user.auth_token,
    //     
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     status: errorTags.apiClevertapProfile.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.status = errorTags.apiClevertapProfile.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.account_id.length <= 0) {
    //       feedback.status = errorTags.apiClevertapProfile.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (canRequest == true) {
    //       // context.commit("loading", { action: "apiClevertapProfile", status: true });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           // context.commit("loading", { action: "apiClevertapProfile", status: false });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == 1;
    //             }
    //             feedback.status = successResponse.body.statusdesc;
    //             if (feedback.success == true) {
    //               try {
    //                 resolve(feedback);
    //               } catch (error) {
    //                 switch (feedback.status) {
    //                   case errorTags.session.expired:
    //                   case errorTags.session.invalidToken:
    //                   case errorTags.session.invalidSession:
    //                   case errorTags.session.inactiveAccount:
    //                     context.commit("delete");
    //                     router.push("/").catch(err => {});
    //                     break;
    //                 }

    //                 reject(feedback);
    //               }
    //             } else {
    //               switch (feedback.status) {
    //                 case errorTags.session.expired:
    //                 case errorTags.session.invalidToken:
    //                 case errorTags.session.invalidSession:
    //                 case errorTags.session.inactiveAccount:
    //                   context.commit("delete");
    //                   router.push("/").catch(err => {});
    //                   break;
    //               }

    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             context.commit("delete");
    //             router.push("/").catch(err => {});
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           // context.commit("loading", { action: "apiClevertapProfile", status: false });
    //           context.commit("delete");
    //           router.push("/").catch(err => {});
    //           feedback.status = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    sulifu(context, user) {
      const url = config.sulifu();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.package_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.sulifu.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.sulifu.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.sulifu.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.sulifu.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.sulifu.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.sulifu == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          context.commit("loading", { action: "sulifu", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "sulifu",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "sulifu",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getXchangeRate(context, user) {
      const url = config.getXchangeRate();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getXchangeRate.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getXchangeRate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getXchangeRate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getXchangeRate == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getXchangeRate", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getXchangeRate", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getXchangeRate", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getRefLink(context, user) {
      const url = config.getRefLink();
      const body = {
        
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        success: false,
        status: errorTags.getRefLink.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getRefLink.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getRefLink.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getRefLink == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getRefLink",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getRefLink",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data= successResponse.body.url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSurveyList",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateEmail(context, user) {
      const url = config.updateEmail();
      const body = {
        
        account_id: user.account_id,
        auth_token: user.auth_token,
        contact_email: user.contact_email
      };
      const feedback = {
        success: false,
        status: errorTags.updateEmail.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.updateEmail.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.status = errorTags.updateEmail.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("contact_email" in user)) {
          feedback.status = errorTags.updateEmail.emailRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.contact_email.length <= 0) {
          feedback.status = errorTags.updateEmail.emailRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateEmail == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateEmail",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateEmail",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSurveyList",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getReferCount(context, user) {
      const url = config.getReferCount();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getReferCount.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getReferCount.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getReferCount.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getReferCount == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getReferCount", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getReferCount", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getReferCount", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getReferRebate(context, user) {
      const url = config.getReferRebate();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getReferRebate.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getReferRebate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getReferRebate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getReferRebate == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getReferRebate", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getReferRebate", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getReferRebate", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getReferCountDetail(context, user) {
      const url = config.getReferCountDetail();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getReferCountDetail.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getReferCountDetail.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getReferCountDetail.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getReferCountDetail == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getReferCountDetail", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getReferCountDetail", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getReferCountDetail", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getReferRebateDetail(context, user) {
      const url = config.getReferRebateDetail();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getReferRebateDetail.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getReferRebateDetail.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getReferRebateDetail.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getReferRebateDetail == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getReferRebateDetail", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getReferRebateDetail", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getReferRebateDetail", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getRebateChart(context, user) {
      const url = config.getRebateChart();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getRebateChart.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getRebateChart.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getRebateChart.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getRebateChart == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getRebateChart", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getRebateChart", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getRebateChart", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getRebate(context, user) {
      const url = config.getRebate();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getRebate.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getRebate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getRebate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getRebate == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getRebate", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getRebate", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getRebate", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getRebateDownline(context, user) {
      const url = config.getRebateDownline();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getRebateDownline.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getRebateDownline.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getRebateDownline.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getRebateDownline == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getRebateDownline", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getRebateDownline", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getRebateDownline", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getTurnoverDownline(context, user) {
      const url = config.getTurnoverDownline();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        working_month: user.working_month,
        page_number: user.page_number,
        page_size: user.page_size
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getTurnoverDownline.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getTurnoverDownline.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getTurnoverDownline.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getTurnoverDownline == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getTurnoverDownline", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getTurnoverDownline", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getTurnoverDownline", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getTurnoverProvider(context, user) {
      const url = config.getTurnoverProvider();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        working_month: user.working_month,
        search_id: user.search_id
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getTurnoverProvider.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getTurnoverProvider.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getTurnoverProvider.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getTurnoverProvider == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getTurnoverProvider", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getTurnoverProvider", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getTurnoverProvider", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    claimRebate(context, user) {
      const url = config.claimRebate();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        amount: user.amount
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.claimRebate.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.claimRebate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.claimRebate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.claimRebate == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "claimRebate", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "claimRebate", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "claimRebate", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    claimRebateDownline(context, user) {
      const url = config.claimRebateDownline();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        amount: user.amount
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.claimRebateDownline.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.claimRebateDownline.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.claimRebateDownline.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.claimRebateDownline == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "claimRebateDownline", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "claimRebateDownline", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "claimRebateDownline", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getProviderGameOfflist(context, user) {
      const url = config.getProviderGameOfflist();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        provider_code: user.provider_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getProviderGameOfflist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getProviderGameOfflist.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getProviderGameOfflist.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("provider_code" in user)) {
          feedback.status = errorTags.getProviderGameOfflist.providerRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.provider_code.length <= 0) {
          feedback.status = errorTags.getProviderGameOfflist.providerRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getProviderGameOfflist == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getProviderGameOfflist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getProviderGameOfflist", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getProviderGameOfflist", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    cnyDeposit(context, user) {
      const url = config.cnyDeposit();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.cnyDeposit.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.cnyDeposit.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.cnyDeposit.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.cnyDeposit == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "cnyDeposit", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "cnyDeposit", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "cnyDeposit", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    missionDetails(context, user) {
      const url = config.missionDetails();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.missionDetails.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.missionDetails.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.missionDetails.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.missionDetails == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "missionDetails", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "missionDetails", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "missionDetails", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    missionClaim(context, user) {
      const url = config.missionClaim();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.missionClaim.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.missionClaim.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.missionClaim.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.missionClaim == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "missionClaim", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "missionClaim", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "missionClaim", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    rayaDeposit(context, user) {
      const url = config.rayaDeposit();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.rayaDeposit.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.rayaDeposit.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.rayaDeposit.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.rayaDeposit == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "rayaDeposit", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "rayaDeposit", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    context.commit("uDepositCount", successResponse.body.value[0].deposit_count);
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "rayaDeposit", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    eurocup(context, user) {
      const url = config.eurocup();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        bet_team: user.bet_team
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.eurocup.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.eurocup.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.eurocup.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.eurocup == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "eurocup", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "eurocup", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "eurocup", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },


    /* sportbook */
    launchWbet(context, user) {
      const url = config.launchWbet();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        type: user.type,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchWbet.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchWbet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchWbet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchWbet == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "launchWbet", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchWbet", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchWbet", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },


    /* slots */
    launchEpic(context, user) {
      const url = config.launchEpic();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchEpic.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchEpic.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchEpic.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchEpic == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchEpic", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchEpic", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchEpic", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchEpic2(context, user) {
      const url = config.launchEpic2();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchEpic2.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchEpic2.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchEpic2.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchEpic2 == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchEpic2", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchEpic2", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchEpic2", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchLive22(context, user) {
      const url = config.launchLive22();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchLive22.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchLive22.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchLive22.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchLive22 == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchLive22", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchLive22", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchLive22", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchHabanero(context, user) {
      const url = config.launchHabanero();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchHabanero.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchHabanero.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchHabanero.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchHabanero == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchHabanero", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchHabanero", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchHabanero", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchSpadeGaming(context, user) {
      const url = config.launchSpadeGaming();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchSpadeGaming.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchSpadeGaming.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchSpadeGaming.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchSpadeGaming == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchSpadeGaming", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchSpadeGaming", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_lobby_url;
                    // feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchSpadeGaming", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchPragmatic(context, user) {
      const url = config.launchPragmatic();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchPragmatic.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchPragmatic.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchPragmatic.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchPragmatic == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchPragmatic", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchPragmatic", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchPragmatic", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchJoker(context, user) {
      const url = config.launchJoker();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchJoker.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchJoker.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchJoker.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchJoker == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchJoker", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchJoker", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchJoker", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchMegaH5(context, user) {
      const url = config.launchMegaH5();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchMegaH5.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchMegaH5.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchMegaH5.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchMegaH5 == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchMegaH5", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchMegaH5", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchMegaH5", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchCq9(context, user) {
      const url = config.launchCq9();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchCq9.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchCq9.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchCq9.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchCq9 == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchCq9", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchCq9", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchCq9", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchJili(context, user) {
      const url = config.launchJili();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchJili.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchJili.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchJili.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchJili == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchJili", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchJili", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchJili", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchOneapi(context, user) {
      const url = config.launchOneapi();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code,
        provider: user.provider
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchOneapi.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchOneapi.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchOneapi.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchOneapi == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchOneapi", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchOneapi", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchOneapi", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },

    /* game result */
    getSpadeResult(context, user) {
      const url = config.getSpadeResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getSpadeResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getSpadeResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getSpadeResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getSpadeResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getSpadeResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getSpadeResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getSpadeResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getSpadeResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getSpadeResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getJokerResult(context, user) {
      const url = config.getJokerResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getJokerResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getJokerResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getJokerResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getJokerResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getJokerResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getJokerResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getJokerResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getJokerResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getJokerResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPpsResult(context, user) {
      const url = config.getPpsResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getPpsResult.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getPpsResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getPpsResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getPpsResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getPpsResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getPpsResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getPpsResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getPpsResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getPpsResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getHbResult(context, user) {
      const url = config.getHbResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getHbResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getHbResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getHbResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getHbResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getHbResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getHbResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getHbResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getHbResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getHbResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getEpic2Result(context, user) {
      const url = config.getEpic2Result();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getEpic2Result.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getEpic2Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getEpic2Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getEpic2Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getEpic2Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getEpic2Result == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getEpic2Result", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getEpic2Result", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getEpic2Result", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getLive22Result(context, user) {
      const url = config.getLive22Result();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getLive22Result.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getLive22Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getLive22Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getLive22Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getLive22Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getLive22Result == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getLive22Result", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getLive22Result", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getLive22Result", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMegaH5Result(context, user) {
      const url = config.getMegaH5Result();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMegaH5Result.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getMegaH5Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getMegaH5Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getMegaH5Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getMegaH5Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getMegaH5Result == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getMegaH5Result", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getMegaH5Result", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getMegaH5Result", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getCq9Result(context, user) {
      const url = config.getCq9Result();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getCq9Result.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getCq9Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getCq9Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getCq9Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getCq9Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getCq9Result == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getCq9Result", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getCq9Result", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getCq9Result", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getJiliResult(context, user) {
      const url = config.getJiliResult();
      const body = {
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getJiliResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getJiliResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getJiliResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getJiliResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getJiliResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getJiliResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getJiliResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getOneapiResult(context, user) {
      const url = config.getOneapiResult();
      const body = {
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getOneapiResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getOneapiResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getOneapiResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getOneapiResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getOneapiResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getOneapiResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getOneapiResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMiniGameBalance(context, user) {
      const url = config.getMiniGameBalance();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMiniGameBalance.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getMiniGameBalance.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getMiniGameBalance.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.getMiniGameBalance == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getMiniGameBalance", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getMiniGameBalance",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getMiniGameBalance",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    spinWheel(context, user) {
      const url = config.spinWheel();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.spinWheel.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.spinWheel.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.spinWheel.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.spinWheel == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "spinWheel", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "spinWheel",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "spinWheel",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getReferralRebateList(context, user) {
      const url = config.getReferralRebateList();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getReferralRebateList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getReferralRebateList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getReferralRebateList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        // if (this.state.user._loading.getReferralRebateList == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getReferralRebateList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getReferralRebateList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getReferralRebateList",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },


    /* cms */
    getAnnBanner(context, user) {
      const url = config.getAnnBanner();
      const body = {
        lang: "all"
      };
      const feedback = {
        success: false,
        status: errorTags.getAnnBanner.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getAnnBanner == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "getAnnBanner", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getAnnBanner", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    var annBeforeLogList = []
                    var annAfterLogList = []
                    if(successResponse.body.value.length > 0){
                      successResponse.body.value.forEach(x => {
                        if(x.banner_type === 1){
                          annBeforeLogList.push(x)
                        }else{
                          annAfterLogList.push(x)
                        }
                      })
                    }
                    if(annBeforeLogList.length > 0){
                      feedback.annBeforeLog = true
                      context.commit("updateAnnBeforeLog", annBeforeLogList);
                    }
                    if(annAfterLogList.length > 0){
                      feedback.annAfterLog = true
                      context.commit("updateAnnAfterLog", annAfterLogList);
                    }
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSlideBanner(context, user) {
      const url = config.getSlideBanner();
      const body = {
        lang: "all"
      };
      const feedback = {
        success: false,
        status: errorTags.getSlideBanner.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getSlideBanner == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "getSlideBanner", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getSlideBanner", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPromoBanner(context, user) {
      const url = config.getPromoBanner();
      const body = {
        lang: "all"
      };
      const feedback = {
        success: false,
        status: errorTags.getPromoBanner.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getPromoBanner == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "getPromoBanner", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getPromoBanner", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSeo(context, user) {
      const url = config.getSeo();
      const body = {
        page_name: user.page_name
      };
      const feedback = {
        success: false,
        status: errorTags.getSeo.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getSeo == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "getSeo", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getSeo", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getNewsList(context, user) {
      const url = config.getNewsList();
      const body = {
        lang: user.lang
      };
      const feedback = {
        success: false,
        status: errorTags.getNewsList.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getNewsList == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "getNewsList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getNewsList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getNewsDetails(context, user) {
      const url = config.getNewsDetails();
      const body = {
        slug: user.slug
      };
      const feedback = {
        success: false,
        status: errorTags.getNewsDetails.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getNewsDetails == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "getNewsDetails", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getNewsDetails", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSeo(context, user) {
      const url = config.getSeo();
      const body = {
        page_name: user.page_name,
        domain_name: user.domain_name
      };
      const feedback = {
        success: false,
        status: errorTags.getSeo.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getSeo == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "getSeo", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getSeo", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
  }
};
